import React from "react"
import {Container} from "react-bootstrap"
import MainComponent from "./Components/MainComponent"
import "./App.css"

function App() {
  return (
    <div className="App">
      <Container fluid>
        <MainComponent />
      </Container>
    </div>
  )
}

export default App
